// English-only dictionary. The site is served exclusively in English.

export const translations = {
  en: {
    // Nav
    "nav.home": "Home",
    "nav.services": "Services",
    "nav.experiences": "Experiences",
    "nav.conceptStore": "Concept Store",
    "nav.recentProjects": "Recent Projects",
    "nav.about": "About",
    "nav.contact": "Contact",
    "nav.book": "BOOK",

    // Buttons / CTAs (global)
    "cta.request": "Request Proposal",
    "cta.discoveryCall": "Book a Discovery Call",
    "cta.exploreServices": "Explore Services",
    "cta.exploreExperiences": "See all Experiences",
    "cta.bookACall": "Book a Discovery Call",

    // Hero
    "hero.kicker": "Since 2016 · Creative Concepts for Entertainment",
    "hero.title.line1": "Nights",
    "hero.title.line2": "That Are",
    "hero.title.line3": "Never",
    "hero.title.line4": "Forgotten.",
    "hero.subtitle":
      "Bespoke entertainment & production for weddings, corporate events, hotels, brand activations and destination events across Europe and the Mediterranean.",
    "hero.scroll": "Scroll",

    // Footer
    "footer.rights": "All rights reserved.",
  },
};
